import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  deleteCandidate,
  getCandidateDeclineReasons,
  updateCandidateStatus,
} from '/redux/action/candidate.action';
import {
  acceptBeforeById,
  hasDeclineReasons,
} from '/redux/selector/candidate.selector';
import {allReportData} from '/redux/selector/report.selector';

import {AcceptDeclineBanner} from './AcceptDeclineBanner';

export default connect(
  createStructuredSelector({
    allReportData,
    acceptBefore: acceptBeforeById,
    hasDeclineReasons,
  }),
  dispatch => ({
    deleteCandidate: ({candidateId, allReportData}: any) =>
      dispatch<any>(deleteCandidate({candidateId, allReportData})),
    updateCandidateStatus: ({candidateId, body, allReportData}: any) =>
      dispatch<any>(updateCandidateStatus({candidateId, body, allReportData})),
    getCandidateDeclineReasons: () =>
      dispatch<any>(getCandidateDeclineReasons({inputPayload: null})),
  }),

  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    deleteCandidate: () => {
      const {candidateId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.deleteCandidate({
        candidateId,
        allReportData,
      });
    },
    updateCandidateStatus: (body: any) => {
      const {candidateId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.updateCandidateStatus({
        candidateId,
        body,
        allReportData,
      });
    },
    getCandidateDeclineReasons: () => {
      return dispatchProps.getCandidateDeclineReasons();
    },
  }),
)(AcceptDeclineBanner);
